import React, { useEffect, useState, useMemo } from "react";
import { Users, Upload } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import debounce from "lodash.debounce";

const Create = () => {
  const [shareWithCompany, setShareWithCompany] = useState(true);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [manualScaleLeft, setManualScaleLeft] = useState("1");
  const [manualScaleRight, setManualScaleRight] = useState("");
  const [showScaleModal, setShowScaleModal] = useState(false);
  const [dwgConvertCheck, setDwgConvertCheck] = useState(false);
  const [invalidScale,setInvalidScale] = useState(false); 
  const [correctScale, setCorrectScale] = useState("");
  const [detectedScale,setDetectedScale] = useState(null);
  const [existingProject, setExistingProject] = useState(null);
  const [projectSuggestions, setProjectSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);


 //After Documentation
  const [clientName, setClientName] = useState("");
  const [masterProject, setMasterProject] = useState("");


  const [elevationInputs, setElevationInputs] = useState([null]);
  const [sectionInputs, setSectionInputs] = useState([null]);
  const [scheduleInputs, setScheduleInputs] = useState([null]);

  const navigate = useNavigate();
  const apiUrl = import.meta.env.VITE_API_URL;
  const pyApiUrl = import.meta.env.VITE_PYTHON_API_URL;

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const submitWithManualScale = async () => {
    try{
  const finalScale =  manualScaleLeft && manualScaleRight  ? `${manualScaleLeft}:${manualScaleRight}` 
    : "Unknown";
    const projectNameInput = document.getElementById("projectName").value;
        
    // console.log(file);
    // debugger;

      
    const formData = new FormData();
    formData.append("client_name", clientName);
    formData.append("project_name", masterProject);
    formData.append("drawing_name", projectNameInput);
    formData.append("share_with_company", shareWithCompany);
    formData.append("file", file);
    formData.append("scale", finalScale);
  
  // HARSHIT CHANGE: Add scale validation data for manual scale entry
  // Create manual scale validation data when user enters scale manually
  const manualScaleValidation = {
    vector_length_pt: null, // Manual entry doesn't have vector data
    dimension_mm: null,     // Manual entry doesn't have dimension data  
    page: 1,
    manual_entry: true,     // Flag to indicate this was manually entered
    manual_scale: finalScale
  };
  formData.append("scale_validation", JSON.stringify(manualScaleValidation));
  
  elevationInputs.forEach(file => {
    if (file) formData.append("elevation_pdf", file);
  });

  sectionInputs.forEach(file => {
    if (file) formData.append("section_pdf", file);
  });

  scheduleInputs.forEach(file => {
    if (file) formData.append("schedule_pdf", file);
  });

  // formData.append("user_id", localStorage.getItem("token"));
  if (existingProject) {
  formData.append("project_id", existingProject._id);
  }

  setLoading(true);

  const response = await fetch(`${apiUrl}/api/projects/store`, {
    method: "POST",
    credentials: "include",
    // headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    body: formData,
  });

    const data = await response.json();
      if (response.ok) {
        toast.success(`Project created successfully!`);
        setShowScaleModal(false);
        setTimeout(() => navigate("/home"), 2000);
      } else {
        toast.error(data.message || "Something went wrong");
      }
     }
     catch (error) {
      console.error(error);
      setLoading(false);
       setShowScaleModal(false);
      toast.error("Server error, please try again later.");
    } finally {
      setLoading(false);
    }
};

  const handleCreateProject = async () => {
    const projectNameInput = document.getElementById("projectName").value;



    if (!projectNameInput) return toast.error("Please enter drawing name");
    if (!file) return toast.error("Please select a file");
    // Elevation & Schedule required only for NEW project
    // if (!existingProject && !elevationFile) {
    //   return toast.error("Please upload Elevation / Section PDF");
    // }
    // if (!scheduleFile) return toast.error("Please upload Schedule PDF");
    if (!clientName) return toast.error("Please enter client name");
    if (!masterProject) return toast.error("Please select master project");

    try {
      setLoading(true);
 
        const isDWG = (file) => {
        const ext = file.name.split(".").pop().toLowerCase();
        return ext === "dwg";
      };

       let finalFile = file; 

      if (isDWG(file)) {

         const conversionForm = new FormData();
          conversionForm.append("file", file);
          setDwgConvertCheck(true);
           const conversionResponse = await fetch(`${apiUrl}/api/projects/dwg-conversion`,
        {
          method: "POST",
          headers: {
          // Authorization: `Bearer ${localStorage.getItem("token")}`,
          credentials: "include",
          }, body: conversionForm,
        }
      );

        const pdfBlob = await conversionResponse.blob();
         finalFile  = new File([pdfBlob], "converted.pdf", { type: "application/pdf",  });   
         setFile(finalFile);
        setDwgConvertCheck(false);
   }

         
        const scaleForm = new FormData();
        scaleForm.append("file", finalFile);

      const scaleResponse = await fetch(`${pyApiUrl}/extract-scale/`, {
        method: "POST",
        // headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        credentials: "include",
        body: scaleForm,
      });
                    
      const scaleData = await scaleResponse.json();

      // Extract scale validation data for storage
      let scaleValidationData = null;
      
      // HARSHIT CHANGE: Better extraction of scale validation data from Python API
      if (scaleData.status === "valid_scale" || scaleData.status === "success") {
        // Check if we have pages array (new format from scale_validate.py)
        if (scaleData.pages && scaleData.pages.length > 0) {
          const firstPage = scaleData.pages[0];
          if (firstPage.vector_length_pt && firstPage.dimension_mm) {
            scaleValidationData = {
              vector_length_pt: firstPage.vector_length_pt,
              dimension_mm: firstPage.dimension_mm,
              page: firstPage.page || 1
            };
            console.log("✅ Extracted scale validation data from pages array:", scaleValidationData);
          }
        }
        // Check if we have direct vector data (fallback format)
        else if (scaleData.vector_length_pt && scaleData.dimension_mm) {
          scaleValidationData = {
            vector_length_pt: scaleData.vector_length_pt,
            dimension_mm: scaleData.dimension_mm,
            page: 1
          };
          console.log("✅ Extracted scale validation data from direct fields:", scaleValidationData);
        }
        // Fallback: try to derive from detected scale if method is vector-based
        else if (scaleData.method_used === "known_dimension_vector" && scaleData.detected_scale) {
           console.warn("⚠️ Scale validation API didn't return vector data, using fallback");
        }
      } else {
        console.warn("⚠️ Scale validation failed or returned invalid status:", scaleData.status);
      }

      // const scale = scaleData?.scale || "Unknown";
      //srathak code start
      let scale  ;
       if(scaleData.detected_scale && scaleData.status == 'valid_scale'){
         scale = `1:${scaleData.detected_scale}`
         setInvalidScale(false);
       }
       else{
          scale = "Unknown";
          if(scaleData.status == 'invalid_scale'){
            const impliedScaleRounded = Math.round(scaleData.implied_scale);
            const scaleDetected = scaleData.detected_scale;
            setManualScaleRight(impliedScaleRounded)
            setDetectedScale(scaleDetected)
            setCorrectScale(impliedScaleRounded);
             setInvalidScale(true);
          }
       }

      setLoading(false);

      if (scale === "Unknown") {
        setShowScaleModal(true);
        return;
      }

      const formData = new FormData();
      formData.append("client_name", clientName);
      formData.append("project_name", masterProject);
      formData.append("drawing_name", projectNameInput);
      formData.append("share_with_company", shareWithCompany);
      formData.append("file", finalFile);
      formData.append("scale", scale);
      
      // Add scale validation data if available
      if (scaleValidationData) {
        formData.append("scale_validation", JSON.stringify(scaleValidationData));
      }
      elevationInputs.forEach(file => {
        if (file) formData.append("elevation_pdf", file);
      });

      sectionInputs.forEach(file => {
        if (file) formData.append("section_pdf", file);
      });

      scheduleInputs.forEach(file => {
        if (file) formData.append("schedule_pdf", file);
      });
      // formData.append("user_id", localStorage.getItem("token"));
      if (existingProject) {
        formData.append("project_id", existingProject._id);
      }
      setLoading(true);
      
      const response = await fetch(`${apiUrl}/api/projects/store`, {
        method: "POST",
        // headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        credentials: "include",
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(`Project created successfully!`);
        setTimeout(() => navigate("/home"), 2000);
      } else {
        toast.error(data.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      toast.error("Server error, please try again later.");
    } finally {
      setLoading(false);
    }
  };



  // Elevation PDF handlers
const handleElevationChange = (index, file) => {
  const updated = [...elevationInputs];
  updated[index] = file;
  setElevationInputs(updated);
};

const addElevationField = () => {
  setElevationInputs([...elevationInputs, null]);
};

const removeElevationField = (index) => {
  const updated = elevationInputs.filter((_, i) => i !== index);
  setElevationInputs(updated);
};

 
// Section PDF handlers
const handleSectionChange = (index, file) => {
  const updated = [...sectionInputs];
  updated[index] = file;
  setSectionInputs(updated);
};

const addSectionField = () => {
  setSectionInputs([...sectionInputs, null]);
};

const removeSectionField = (index) => {
  const updated = sectionInputs.filter((_, i) => i !== index);
  setSectionInputs(updated);
};

// Schedule PDF handlers
const handleScheduleChange = (index, file) => {
  const updated = [...scheduleInputs];
  updated[index] = file;
  setScheduleInputs(updated);
};

const addScheduleField = () => {
  setScheduleInputs([...scheduleInputs, null]);
};

const removeScheduleField = (index) => {
  const updated = scheduleInputs.filter((_, i) => i !== index);
  setScheduleInputs(updated);
};


const fetchProjects = async (value) => {
  if (!value) {
    setProjectSuggestions([]);
    setShowSuggestions(false);
    setClientName("");
    return;
  }

  const res = await fetch(
    `${apiUrl}/api/projects/search?project_name=${value}`,
    { credentials: "include" }
  );

  const data = await res.json();
  setProjectSuggestions(data.projects || []);
  setShowSuggestions(true);
};


const debouncedFetch = useMemo(() => {
  return debounce(fetchProjects, 300);
}, []);

// cleanup
useEffect(() => {
  return () => {
    debouncedFetch.cancel();
  };
}, []);


  return (
    <div className="flex-1 flex items-center justify-center p-4 min-h-screen pt-20 pb-8 relative overflow-y-auto">
      {loading && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-[#1b263b] p-6 rounded-xl shadow-lg flex flex-col items-center">
            <div className="border-4 border-blue-400 border-t-transparent rounded-full w-12 h-12 animate-spin mb-4"></div>
            <p className="text-white text-sm">
             { dwgConvertCheck?"Converting DWG File" :"Detecting scale, please wait..."}            </p>
          </div>
        </div>
      )}


    {showScaleModal && (
<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
  <div className="bg-[#1b263b] p-6 rounded-xl shadow-lg max-w-md w-full mx-4">

    {invalidScale? (
        <>     
              <h3 style={{ fontWeight: 700, fontSize: "1.4rem" }}>
            Invalid Scale(1: {detectedScale})
          </h3>
        
          <p style={{ fontWeight: 600, fontSize: "1.05rem" }}>
            Scale detected from the drawing is Invalid.
          </p>
        
          {correctScale && (
          <p style={{ fontWeight: 700, fontSize: "1.1rem" }}>
          (Suggested Scale:{" "}
          <span style={{ fontSize: "1.2rem" }}>
            1 : {correctScale}
          </span>
          )
        </p>
          )}
            </>
            ):(
            <>
        <h3 style={{ fontWeight: 700, fontSize: "1.4rem" }}>
            Scale Not Detected
          </h3>
         <br />
          <p style={{ fontWeight: 600, fontSize: "1.05rem" }}>
            The CAD file does not contain scale information.
            Please enter drawing scale.
          </p>
          <br />
            </>)}
          
        
        <div className="d-flex gap-2 align-items-center">
          <input
            type="text"
            placeholder="1"
            value={manualScaleLeft}
            onChange={(e) => setManualScaleLeft(e.target.value)}
            className="modal-input scale-input"
          />
        
          <span className="scale-separator">:</span>
        
          <input
            type="text"
            placeholder="100"
            value={manualScaleRight}
            onChange={(e) => setManualScaleRight(e.target.value)}
            className="modal-input scale-input"
          />
        </div>
        

        <div className="flex gap-3 mt-6">
          <button 
            className="flex-1 py-2 px-4 bg-blue-600 hover:bg-blue-700 rounded-lg transition-all font-medium" 
            onClick={submitWithManualScale}
          >
            Submit
          </button>
          <button 
            className="flex-1 py-2 px-4 bg-gray-600 hover:bg-gray-700 rounded-lg transition-all font-medium" 
            onClick={() => setShowScaleModal(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>

    )} 

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />

      <div className="bg-[#1b263b]/80 backdrop-blur-lg rounded-2xl shadow-2xl w-full max-w-6xl flex flex-col lg:flex-row border border-[#2d3e56] overflow-hidden">
        <div className="flex-1 p-4 lg:p-6 space-y-4 lg:space-y-6 max-h-screen overflow-y-auto">
          <div>
            <h2 className="text-xl lg:text-2xl font-bold mb-2">Create New Project</h2>
            <p className="text-gray-400 text-sm lg:text-base">
              Start by naming your project and setting up permissions
            </p>
          </div>

          <div className="space-y-4">


          <div className="relative">
  <label className="block text-sm font-medium text-gray-300 mb-2">
    Project Name
  </label>

  <input
    type="text"
    placeholder="Enter project name..."
    value={masterProject}
    className="w-full px-4 py-3 bg-[#0d1b2a] border border-[#2d3e56] rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all"
    onChange={async (e) => {
      const value = e.target.value;
      setMasterProject(value);
      setExistingProject(null);

      // if (!value) {
      //   setProjectSuggestions([]);
      //   setShowSuggestions(false);
      //   setClientName("");
      //   return;
      // }
          
      // const res = await fetch(
      //   `${apiUrl}/api/projects/search?project_name=${value}`,
      //   {
      //     credentials: "include",
      //   }
      // );

      // const data = await res.json();
      // setProjectSuggestions(data.projects || []);
      // setShowSuggestions(true);

      debouncedFetch(value); 
    }}
  />

  {/* 🔽 Dropdown yahin lagega */}
  {showSuggestions && projectSuggestions.length > 0 && (
    <ul className="absolute z-50 w-full bg-[#0d1b2a] border border-[#2d3e56] rounded-xl mt-1 max-h-48 overflow-y-auto shadow-lg">
      {projectSuggestions.map((proj) => (
        <li
          key={proj._id}
          className="px-4 py-3 hover:bg-blue-600 cursor-pointer border-b border-[#2d3e56] last:border-b-0 transition-colors"
          onClick={() => {
            setMasterProject(proj.project_name);
            setExistingProject(proj);
            setClientName(proj.client_name);
            setShowSuggestions(false);
          }}
        >
          <div className="font-medium text-white text-sm lg:text-base">{proj.project_name}</div>
          <div className="text-xs text-gray-400">
            Client: {proj.client_name}
          </div>
        </li>
      ))}
    </ul>
  )}
</div>



          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Client Name
            </label>
            <input
              type="text"
              placeholder="Enter client name..."
              value={clientName}
              readOnly={!!existingProject}
              className={`w-full px-4 py-3 text-white border border-[#2d3e56] rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all ${
                existingProject ? "bg-gray-700 cursor-not-allowed" : "bg-[#0d1b2a]"
              }`}
              onChange={(e) => setClientName(e.target.value)}
            />
          </div>




            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Drawing Name
              </label>
              <input
                type="text"
                id="projectName"
                placeholder="Enter drawing name..."
                className="w-full px-4 py-3 bg-[#0d1b2a] border border-[#2d3e56] rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all text-white"
              />
            </div>

            <div className="flex items-center justify-between p-4 bg-[#0d1b2a] rounded-xl border border-[#2d3e56]">
              <div className="font-medium">Share with company</div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={shareWithCompany}
                  onChange={() => setShareWithCompany(!shareWithCompany)}
                  className="sr-only"
                />
                <div className="w-12 h-6 bg-gray-700 rounded-full peer peer-checked:bg-blue-600 transition-all duration-300"></div>
                <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full peer-checked:translate-x-6 transition-all duration-300 shadow-lg"></div>
              </label>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Project Template
              </label>
              <select className="w-full px-4 py-3 bg-[#0d1b2a] border border-[#2d3e56] rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all text-white">
                <option>Start from scratch</option>
                <option>Architecture Template</option>
                <option>Urban Planning Template</option>
                <option>Landscape Design Template</option>
              </select>
            </div>

            <button
              onClick={handleCreateProject}
              disabled={loading}
              className={`w-full py-3 rounded-xl transition-all font-medium shadow-lg shadow-blue-600/20 text-sm lg:text-base ${
                loading
                  ? "bg-gray-600 cursor-not-allowed"
                  : "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
              }`}
            >
              {loading ? "Processing..." : "Create Project"}
            </button>
          </div>
        </div>

        <div className="flex-1 border-t lg:border-t-0 lg:border-l border-[#2d3e56] p-4 lg:p-8 max-h-screen overflow-y-auto">
          <div className="flex flex-col items-center justify-center border-2 border-dashed border-[#2d3e56] rounded-2xl p-4 lg:p-8 hover:border-blue-500/50 transition-all duration-300 group min-h-[200px]">
            <div className="text-center space-y-4">
              <div className="inline-flex p-4 bg-blue-500/10 rounded-2xl">
                <Upload size={32} className="text-blue-400" />
              </div>
              <h3 className="font-semibold text-base lg:text-lg mb-2">Upload Map View</h3>
              <p className="text-gray-400 text-xs lg:text-sm">
                Drag & Drop your files here or browse
              </p>

              <div className="bg-[#0d1b2a] rounded-lg p-4 border border-[#2d3e56]">
                <p className="text-sm font-medium mb-2">Supported formats:</p>
                <p className="text-xs text-gray-400 leading-6">
                  PDF, DWG, DXF, DWF, DGN, PNG, TIFF, JPG, JPEG, BMP, EMF, GIF
                </p>
              </div>

              <input
                type="file"
                id="fileUpload"
                onChange={handleFileChange}
                className="hidden"
              />
              <label
                htmlFor="fileUpload"
                className="px-4 lg:px-6 py-2 bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all font-medium shadow-lg shadow-blue-600/20 cursor-pointer text-sm lg:text-base"
              >
                Browse Files
              </label>

              {file && (
                <p className="text-xs lg:text-sm text-gray-300 mt-3 break-all">
                  Selected: <span className="font-medium">{file.name}</span>
                </p>
              )}
            </div>

          {/* Elevation Drawing */}
          <div className="mt-4 lg:mt-6 w-full bg-[#0f2238] p-3 lg:p-4 rounded-xl border border-[#2d3e56]">
            
            <div className="flex items-center justify-between mb-3">
              <label className="text-xs lg:text-sm font-semibold text-gray-300">
                Elevation Drawings (PDF)
              </label>

              <button
                type="button"
                onClick={addElevationField}
                className="px-2 lg:px-3 py-1 text-xs bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
              >
                + Add
              </button>
            </div>

            {elevationInputs.map((file, index) => (
              <div
                key={index}
                className="flex items-center gap-3 mb-3 bg-[#0d1b2a] p-3 rounded-lg border border-[#2d3e56]"
              >
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) =>
                    handleElevationChange(index, e.target.files[0])
                  }
                  className="flex-1 text-xs lg:text-sm text-white"
                />

                {file && (
                  <span className="text-xs text-gray-400 truncate max-w-[120px]">
                    {file.name}
                  </span>
                )}

                {index !== 0 && (
                  <button
                    type="button"
                    onClick={() => removeElevationField(index)}
                    className="px-2 py-1 text-xs bg-red-500 hover:bg-red-600 rounded"
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}
          </div>     

          {/* Section Drawing */}
          <div className="mt-4 lg:mt-6 w-full bg-[#0f2238] p-3 lg:p-4 rounded-xl border border-[#2d3e56]">
            
            <div className="flex items-center justify-between mb-3">
              <label className="text-xs lg:text-sm font-semibold text-gray-300">
                Section Drawings (PDF)
              </label>

              <button
                type="button"
                onClick={addSectionField}
                className="px-2 lg:px-3 py-1 text-xs bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
              >
                + Add
              </button>
            </div>

            {sectionInputs.map((file, index) => (
              <div
                key={index}
                className="flex items-center gap-3 mb-3 bg-[#0d1b2a] p-3 rounded-lg border border-[#2d3e56]"
              >
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) =>
                    handleSectionChange(index, e.target.files[0])
                  }
                  className="flex-1 text-xs lg:text-sm text-white"
                />

                {file && (
                  <span className="text-xs text-gray-400 truncate max-w-[120px]">
                    {file.name}
                  </span>
                )}

                {index !== 0 && (
                  <button
                    type="button"
                    onClick={() => removeSectionField(index)}
                    className="px-2 py-1 text-xs bg-red-500 hover:bg-red-600 rounded"
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}
          </div>  

          {/* Schedule PDFs */}
          <div className="mt-4 lg:mt-6 w-full bg-[#0f2238] p-3 lg:p-4 rounded-xl border border-[#2d3e56]">
            
            <div className="flex items-center justify-between mb-3">
              <label className="text-xs lg:text-sm font-semibold text-gray-300">
                Schedule PDFs
              </label>

              <button
                type="button"
                onClick={addScheduleField}
                className="px-2 lg:px-3 py-1 text-xs bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
              >
                + Add
              </button>
            </div>

            {scheduleInputs.map((file, index) => (
              <div
                key={index}
                className="flex items-center gap-3 mb-3 bg-[#0d1b2a] p-3 rounded-lg border border-[#2d3e56]"
              >
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) =>
                    handleScheduleChange(index, e.target.files[0])
                  }
                  className="flex-1 text-xs lg:text-sm text-white"
                />

                {file && (
                  <span className="text-xs text-gray-400 truncate max-w-[120px]">
                    {file.name}
                  </span>
                )}

                {index !== 0 && (
                  <button
                    type="button"
                    onClick={() => removeScheduleField(index)}
                    className="px-2 py-1 text-xs bg-red-500 hover:bg-red-600 rounded"
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}
          </div>   

          </div>

          

        </div>
      </div>
    </div>
  );
};

export default Create;
